"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretDownIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var CaretDownIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M16.7142857,9.60714286 C16.7142857,9.7715782 16.6542045,9.91387589 16.5340402,10.0340402 L12.2840402,14.2840402 C12.1638759,14.4042045 12.0215782,14.4642857 11.8571429,14.4642857 C11.6927075,14.4642857 11.5504098,14.4042045 11.4302455,14.2840402 L7.18024554,10.0340402 C7.06008124,9.91387589 7,9.7715782 7,9.60714286 C7,9.44270751 7.06008124,9.30040983 7.18024554,9.18024554 C7.30040983,9.06008124 7.44270751,9 7.60714286,9 L16.1071429,9 C16.2715782,9 16.4138759,9.06008124 16.5340402,9.18024554 C16.6542045,9.30040983 16.7142857,9.44270751 16.7142857,9.60714286 Z" }))); };
exports.CaretDownIcon = CaretDownIcon;
